import { Injectable } from "@angular/core";
import { ApiHttp } from "@core/api/api-http";
import { OpportunityApiHttp } from "@core/api/opportunity-api-http";
import { OpportunitySummary } from "@features/opportunities/models/opportunity";
import { Observable } from "rxjs";
import { AliGroupService } from "../modules/ali-group-insurance/services/ali-group.service";

@Injectable({
  providedIn: 'root'
})
export class OpportunitySummaryService {

  constructor(
    private http: OpportunityApiHttp,
    private aliGroupService: AliGroupService
  ) {}

  getSummaryForDisplay(
    id: string,
    withRequirementsAndViolations: boolean = false,
    withOpportunitySummary: boolean = false
  ): Observable<OpportunitySummary> {
    return this.http.getWithFeatures<OpportunitySummary>(
      `opportunities/${id}`,
      {
        headers: ApiHttp.getStandardOptions().headers,
        params: {
          depth: 4
        }
      },
      OpportunityApiHttp.features(
        withRequirementsAndViolations,
        withOpportunitySummary
      )
    );
  }

  checkBrokerAccreditation(id: string): Observable<boolean> {
    return this.aliGroupService.checkBrokerAccreditation(id);
  }
}